import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import {
  deleteLink,
  fetchLinksByCompactIndicatorId,
} from '../../../store/landscapeAPI/link/reducers/link.slice';
import { AppDispatch, RootState } from '../../../store/store';
import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeIndicatorExternalResourcesTemplate } from '../../templates';

// import styles from './LandscapeIndicatorExternalResourcesPage.module.css';

const LandscapeIndicatorExternalResourcesPage: FC = () => {
  const { links, status } = useSelector((state: RootState) => state.linkSlice);

  const dispatch = useDispatch<AppDispatch>();

  const navigate = useNavigate();

  const { id, landscapeIndicatorId } = useParams();

  useEffect(() => {
    if (landscapeIndicatorId) {
      dispatch(fetchLinksByCompactIndicatorId(landscapeIndicatorId));
    }
  }, [dispatch, landscapeIndicatorId]);

  const handleDeleteLink = (existingId: string) => {
    if (id && landscapeIndicatorId) {
      dispatch(deleteLink({ existingId, compactId: id, landscapeIndicatorId }));
    }
  };

  const handleUpdateLink = (resourceId: string) => {
    navigate(
      `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/external-resources/edit/${resourceId}`
    );
  };

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <LandscapeIndicatorExternalResourcesTemplate
      data={links ?? []}
      handleDeleteLink={handleDeleteLink}
      handleUpdateLink={handleUpdateLink}
    />
  );
};

export default LandscapeIndicatorExternalResourcesPage;
